import { actionTypes } from "../actions/ui";

const initialState = {
    notification: {
      type: null,
      text: null
    }
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_NOTIFICATION: {
      return {
          ...state,
          notification: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default uiReducer;
